import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idSubCategoriesDelete } from '../../../adminSlice';

export default class DeleteInputFormsForSubCategories  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            sub_id: this.props.adminState.selectedId,
           // main_name: this.state.userInputContent,
            
        }
        console.log(item);
        dispatch(idSubCategoriesDelete(item));  
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
   // let  data =  this.props.data;
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputFormsForSubCategories) {
        return(
            <div className="InputFormsForQuizes">
                <p className='p-text'>id: {this.props.adminState.selectedId}</p>
                <p className='p-text'>Подкатегория: {this.props.adminState.dataSubCategoryId.map(item => {
              // console.log(item)
                if (item.id === Number(this.props.adminState.selectedId))
               //console.log(item.label)
                {return item.text;} else return null;
                })}
                </p>
                


             <p>Вы действительно хотите удалить данную подкатегорию?</p>
             <p className='p-text'>(Удалить возможно только <strong> пустую </strong>подкатегорию)</p>
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}